import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AuthSuccessPage: React.FC = () => {
  const navigate = useNavigate();
  const { checkAuthStatus } = useAuth();
  const [authChecked, setAuthChecked] = useState(false);

  useEffect(() => {
    const handleAuthSuccess = async () => {
      console.log('Auth success page loaded, checking auth status...');
      
      try {
        // Check auth status to update the context
        await checkAuthStatus();
        
        // Mark that we've checked auth status
        setAuthChecked(true);
      } catch (error) {
        console.error('Error in auth success handler:', error);
        navigate('/login', { replace: true });
      }
    };

    handleAuthSuccess();
  }, [checkAuthStatus, navigate]);

  // Separate effect to handle navigation after auth status is updated
  const { isAuthenticated, isAdmin } = useAuth();
  
  useEffect(() => {
    if (!authChecked) return; // Wait until auth status has been checked
    
    console.log('Auth status updated, isAuthenticated:', isAuthenticated, 'isAdmin:', isAdmin);
    
    // Small delay to ensure all state updates are complete
    const timer = setTimeout(() => {
      if (isAuthenticated) {
        console.log('User is authenticated, redirecting to', isAdmin ? '/admin' : '/');
        // Redirect to admin dashboard if user is admin, otherwise to home
        navigate(isAdmin ? '/admin' : '/', { replace: true });
      } else {
        console.log('User is not authenticated, redirecting to login');
        // If not authenticated, redirect to login
        navigate('/login', { replace: true });
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [authChecked, isAuthenticated, isAdmin, navigate]);

  return (
    <div className="auth-success-page">
      <div className="auth-success-container">
        <div className="auth-success-content">
          <div className="loading-state">
            <div className="loading-spinner"></div>
            <p>Loading...</p>
          </div>
          <h2>Authentication Successful!</h2>
          <p>Redirecting you to the dashboard...</p>
        </div>
      </div>
    </div>
  );
};

export default AuthSuccessPage; 